<template>
  <v-row dense class="mb-5">
    <v-col>
      <!--CALLS MAIN PAGE AD IN PLACE OF CAROUSEL-->
      <template v-if="name === 'Main Page Ad'">
          <MainPageAd class="mx-auto" :mainPageAd="mainPageAd" v-if="mainPageAd"></MainPageAd>
      </template>

      <template v-else>
        <div class="d-flex align-center justify-space-between">
          <div class="d-flex align-center">
            <h2 class="mr-3">{{ name }}</h2>
          </div>
          <v-btn dark :to="seeMoreLink" v-if="!suggested" @click.native="$gtag.clickButton('See More Broadcasts')">
            See More
          </v-btn>
        </div>
        <template v-if="loading">
          <p class="text-center">Loading {{ name }}...</p>
          <p class="text-center">
            <v-progress-circular indeterminate :size="50" color="primary"></v-progress-circular>
          </p>
        </template>
        <template v-else>
          <template v-if="broadcasts.length > 0">
            <v-sheet color="transparent" class="pa-3">
              <div class="carouselContainer">
                <div class="itemWrapper d-flex overflow-x-auto" ref="wrapper">
                  <v-card
                    :width="itemWidth"
                    style="min-height: 145px;"
                    :to="'/stream/' + broadcast.id + '/' + seoName(broadcast.title)"
                    @click.native="$gtag.clickLink(broadcast.title)"
                    v-for="broadcast in broadcasts"
                    :key="broadcast.id"
                    class="mr-4"
                    ref="broadcast_card"
                  >
                    <v-img :src="broadcast.banner" :width="itemWidth" :height="imageHeight"></v-img>
                    <v-card-text class="px-2 pb-1 pt-1 broadcastText">
                      <template v-if="broadcast.stage === 'scheduled'">
                        <p class="broadcastTitle font-weight-bold mb-0">
                          {{ broadcast.title }}
                        </p>
                        <p class="mb-1" v-if="broadcast.subtitle">
                          {{ broadcast.subtitle }}
                        </p>
                        <p class="broadcastTime text-center font-weight-bold mb-1">{{ broadcast.weekday }} @ {{ broadcast.start_time_formatted }}</p>
                        <div class="text-center pb-1">
                          <template v-if="broadcast.stage === 'scheduled'">
                            <v-chip small class="ml-2">Scheduled</v-chip>
                          </template>
                        </div>
                      </template>

                      <template v-else-if="broadcast.stage === 'live'">
                        <p class="broadcastTitle font-weight-bold mb-0">
                          {{ broadcast.title }}
                        </p>
                        <p class="mb-1" v-if="broadcast.subtitle">
                          {{ broadcast.subtitle }}
                        </p>
                        <div class="text-center py-2">
                          <template v-if="broadcast.stage === 'live'">
                            <v-chip small class="ml-2" color="error" outlined>Live Now</v-chip>
                          </template>
                        </div>
                      </template>

                      <template v-else>
                        <p class="broadcastTitle font-weight-bold mb-0">
                          {{ broadcast.title }}
                        </p>
                        <p class="mb-1" v-if="broadcast.subtitle">
                          {{ broadcast.subtitle }}
                        </p>
                        <p class="broadcastTime text-center font-weight-bold mb-1">
                          {{ broadcast.date_formatted }}
                        </p>
                      </template>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
            </v-sheet>
          </template>
          <template v-else>
            <div class="d-flex justify-start align-center">
              <p class="subtitle-1 mb-0">There are currently no {{ name }} broadcasts.</p>
              <v-btn
                class="ml-5"
                @click.native="
                  refresh();
                  $gtag.clickButton('Refresh ' + name + ' broadcasts');
                "
                small
              >
                Refresh
                <v-icon right>mdi-refresh</v-icon>
              </v-btn>
            </div>
          </template>
        </template>
        <v-divider class="my-5"></v-divider>
      </template>
    </v-col>
  </v-row>
</template>
<script>
import seoNameMixin from '../mixins/seoNameMixin';
import MainPageAd from './MainPageAd.vue';
export default {
  components: {MainPageAd },
  mixins: [seoNameMixin],
  props: {
    name: {
      type: String,
      required: false,
    },
    itemWidth: {
      type: Number,
      required: false,
      default: 200,
    },
    apiEndpoint: {
      type: String,
      required: false,
    },
    categoryId: {
      type: [String, Number],
      required: false,
    },
    categorySeoName: {
      type: String,
      required: false,
    },
    suggested: {
      type: Boolean,
      default: false,
    },
    broadcastId: {
      type: [Number, String],
      required: false,
    },
  },
  data: () => ({
    timeout: null,
    loading: false,
    broadcasts: [],
    refreshInterval: null,
    mainPageAd: null,
  }),
  computed: {
    imageHeight() {
      return this.itemWidth * 0.37;
    },
    seeMoreLink() {
      if (!this.categoryId || !this.categorySeoName) {
        return '/broadcasts';
      }
      return `/broadcasts/${this.categoryId}/${this.categorySeoName}`;
    },
  },
  methods: {
    refresh() {
      this.getBroadcasts();
      if (this.name == 'Main Page Ad') { this.getMainPageAd(); } //Load mainPageAd but prevent unnecessary calls
    },
    getBroadcasts() {
      this.loading = true;
      if (this.categoryId) {
        axios.get(`getBroadcastsByCategoryId?id=${this.categoryId}`).then(({ data }) => {
          if (data.success) {
            this.broadcasts = data.broadcasts;
          }
          this.loading = false;
        });
      } else if (this.apiEndpoint) {
        axios.get(this.apiEndpoint).then(({ data }) => {
          if (data.success) {
            this.broadcasts = data.broadcasts;
          }
          this.loading = false;
        });
      } else if (this.suggested) {
        this.loading = true;
        axios.get('getSuggestedBroadcasts', { broadcastId: this.broadcastId }).then(({ data }) => {
          if (data.success) {
            this.broadcasts = data.broadcasts;
          }
          this.loading = false;
        });
      }
    },
    async getMainPageAd() {
      const response = await axios.get('getMainPageAd');
      this.mainPageAd = response.data.mainPageAd;
    },
  },
  watch: {
    broadcastId(val) {
      if (val) {
        this.getBroadcasts();
      }
    },
    categoryId(val) {
      if (val) {
        this.getBroadcasts();
      }
    },
    apiEndpoint(val) {
      if (val) {
        this.getBroadcasts();
      }
    }
  },
  created() {
    this.getBroadcasts();
    if (this.name == 'Main Page Ad') { this.getMainPageAd(); } //Load mainPageAd but prevent unnecessary calls
    
    this.refreshInterval = setInterval(() => {
      this.getBroadcasts();
      console.log(`refreshed ${this.name} Broadcasts at`, new Date());
    }, 300000); // 5 minutes
  },
  beforeDestroy() {
    clearInterval(this.refreshInterval);
  },
};
</script>
<style lang="scss">
.broadcastText {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  & > * {
    width: 100%;
    display: block;
    text-align: center;
  }
}
.broadcastTitle {
  color: #fff;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.25;
  text-align: center;
}
.broadcastTime {
  overflow: visible;
  font-size: 90%;
}
.carouselContainer {
  position: relative;
}
.carouselContainer .itemWrapper::-webkit-scrollbar {
  height: 10px;
  background-color: #656565;
  border-radius: 5px;
}
.carouselContainer .itemWrapper::-webkit-scrollbar-thumb {
  background-color: #656565;
  border: 1px solid #555555;
  border-radius: 5px;
}
.carouselContainer .itemWrapper::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  background-color: #333;
  border-radius: 5px;
}
.carouselContainer .itemWrapper {
  flex-wrap: nowrap;
  padding-bottom: 10px;
}
</style>
